import {
  Show,
  SimpleShowLayout,
  NumberField,
  DateField,
  FunctionField,
  BooleanField,
} from "react-admin";
import { StatusChip } from "../../../../components/StatusChip";
import { CopyableId } from "../../../../components/CopyableId";

export const RoundShow = () => (
  <Show>
    <SimpleShowLayout>
      <FunctionField
        label="Round ID"
        render={(r: { roundId?: string }) => <CopyableId value={r?.roundId} />}
      />
      <FunctionField
        label="State"
        render={(r: { state?: string }) => <StatusChip value={r?.state} />}
      />
      <NumberField source="crashPoint" label="Crash Point" />
      <FunctionField
        label="Server Seed"
        render={(r: { serverSeed?: string }) => (
          <CopyableId value={r?.serverSeed} />
        )}
      />
      <FunctionField
        label="Fairness Hash"
        render={(r: { fairnessHash?: string }) => (
          <CopyableId value={r?.fairnessHash} />
        )}
      />
      <DateField source="initializedAt" label="Initialized" showTime />
      <DateField source="startedAt" label="Started" showTime />
      <DateField
        source="bettingClosingStartedAt"
        label="Betting Closing"
        showTime
      />
      <DateField source="flyingStartedAt" label="Flying Started" showTime />
      <DateField source="crashedAt" label="Crashed" showTime />
      <NumberField
        source="bettingOpenDurationMillis"
        label="Betting Open (ms)"
      />
      <NumberField
        source="bettingClosingDurationMillis"
        label="Betting Closing (ms)"
      />
      <NumberField source="crashedDurationMillis" label="Crashed (ms)" />
      <BooleanField source="markedForOutbox" label="Marked for Outbox" />
      <DateField source="createdAt" label="Created" showTime />
      <DateField source="updatedAt" label="Updated" showTime />
    </SimpleShowLayout>
  </Show>
);
